import * as React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { type TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { Box } from '@mui/material'
import { grey } from '../../colors'

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }}/>
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: grey[850]
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: grey[850],
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    borderRadius: theme.spacing(1.5)
  }
}))

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  children: React.ReactNode
  title: React.ReactNode
  placement?: TooltipProps['placement']
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ children, title, placement = 'top', ...props }) => {
  return (
    <StyledTooltip placement={placement} title={title} {...props} >
      <Box> {children}</Box>
    </StyledTooltip >
  )
}

export default CustomTooltip
